
export default {
    props: {
        initialQuery: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Object],
            default: () => ({})
        },
        minQuery: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Space Force',
        },
        btnLabel: {
            type: String,
            default: 'Find & Verify Group'
        },
        helpText: {
            type: String,
            default: null,
        },
        nonParticipatingAlert: {
            type: Boolean,
            default: true
        },
        levels: {
            type: Array,
            default: () => ['paying', 'financial_advisor', 'dpc']
        }
    },
    computed: {
        // #730: forwarded only when a parent listens, so GroupFind keeps its own
        // "does not participate" message for every other consumer.
        nonParticipatingListener () {
            if (!this.$listeners['non-participating']) return {}
            return { 'non-participating': group => this.$emit('non-participating', group) }
        },
    },
    methods: {
        onInputRaw (group) {
            if (group?.id) {
                this.$store.commit('group', group)
            }
            this.$emit('set-value', { key: 'group_name', value: group?.name || '' })
            // Re-emit the raw group so consumers that need the full object
            // (e.g. the V2 scheduler's eligibility step) can react to it.
            // Additive — existing listeners that only use @input / @set-value
            // are unaffected.
            this.$emit('input-raw', group)
        }
    }
}
